module.exports = __webpack_public_path__ + "img/hero-vanguards-le_fwt20.2e3e065.jpg";